export default {
  data () {
    return {
      meta: {
        current_page: 1,
        last_page: 0,
        total: 0,
        per_page: 10,
        sort: 'id',
        direction: 'desc',
        limits: [
          10, 20, 50, 100, 500
        ],
        filter: {}
      },
      items: []
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    getService () {
      throw Error('You must implement getService()')
    },
    reload () {
      this.paginate(this.meta)
    },
    changeOrder (key, direction) {
      this.meta.sort = key
      this.meta.direction = direction
      this.reload()
    },
    paginate (meta) {
      this.setLoading(true)
      this.getService().paginate(meta).then(this.successPaginate, this.errorPaginate)
    },
    changePage (page) {
      this.meta.current_page = page
      this.paginate(this.meta)
    },
    changeLimit (limit) {
      this.meta.per_page = limit
      this.meta.current_page = 1
      this.paginate(this.meta)
    },
    errorPaginate () {
      this.setLoading(false)
    },
    successPaginate (res) {
      this.items = res.data.items
      const filter = this.meta.filter
      this.meta = res.data.meta
      this.meta.filter = filter
      this.setLoading(false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Paginate.js